import moment from 'moment';

export function compareByIdDesc(a, b) {
    if (a.id < b.id) {
        return 1;
    }
    if (a.id > b.id) {
        return -1;
    }
    return 0;
}

export function incrementYearMonth(yearMonth){
    {/* yyyy-mm-dd 2026-06 -> 2026-07 */ }
    const ym = yearMonth.split("-")

    if(ym[1] == 12){
        return `${parseInt(ym[0],10)+1}-01`
    } else {
        const mm = String(parseInt(ym[1],10)+1).padStart(2,'0');
        return `${ym[0]}-${mm}`
    }
}
export function decrementYearMonth(yearMonth){
    {/* yyyy-mm-dd 2026-06 -> 2026-05 */ }

    const ym = yearMonth.split("-")   
    if(ym[1] == 1){
        return `${parseInt(ym[0],10)-1}-12`
    } else {
        const mm = String(parseInt(ym[1],10)-1).padStart(2,'0');
        return `${ym[0]}-${mm}`
    }
}

export function yearMonthPlusDay(yearMonth, day){
    {/* yyyy-mm-dd */ }
    const dd = String(day).padStart(2,'0');
    const formattedDate = `${yearMonth}-${dd}`;
    return formattedDate;
}

export function yearMonthDayToday(){
    {/* yyyy-mm-dd */ }
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2,'0');
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    return formattedDate;
}

export function yearMonthDay(day){
    {/* yyyy-mm-dd */ }
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(day).padStart(2,'0');
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    return formattedDate;
}

export function yearMonth() {
    {/* yyyy-mm */ }
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const formattedDate = `${yyyy}-${mm}`;
    return formattedDate
}

export function daysBetweenDates(startDate, endDate) {
    {/* yyyy-mm-dd */ }
    var sd = moment(startDate)
    var ed = moment(endDate)
    return Math.abs(sd.diff(ed, "days"))
}

export function dateFromDate(startDate, daysApart) {
    {/* yyyy-mm-dd, +-N */ }
    var sd = moment(startDate)
    if (daysApart > 0) {
        return sd.add(daysApart, "days").format('YYYY-MM-DD')
    } else if (daysApart < 0) {
        return sd.subtract(daysApart * -1, "days").format('YYYY-MM-DD')
    }
    return startDate;
}

export function dateStringShort(date) {
    {/* "yyyy-mm-dd" -> "yy.mm.dd" */ }
    let parts = date.split("-")
    parts[0] = parts[0].substring(2)
    return parts.join(".")
}

export function dateTimeConverter(dateObj) {
    {/* returns ["yyyy-mm-dd", "hh:mm"] */ }
    let h = dateObj.getHours() < 10 ? "0" + dateObj.getHours() : dateObj.getHours()
    let m = dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes()
    return [dateObj.toLocaleString("sv").split(" ")[0], h + ":" + m]
}

export function dayOfWeek(date) {
    {/* "yyyy-mm-dd" -> "Monday" */ }
    const weekday = [
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ]
    const d = new Date(date)
    return weekday[d.getDay()]
}

export function dayOfWeekShort(date) {
    {/* "yyyy-mm-dd" -> "mon" */ }
    const weekday = [
        "sun", "mon", "tue", "wed", "thu", "fri", "sat"
    ]
    const d = new Date(date)
    return weekday[d.getDay()]
}

export function format24h(stringTime) {
    {/* "13:27:00" -> "1:27 pm" */ }
    let parts = stringTime.split(":")

    if (parts[0].substr(0, 1) === "0") {
        parts[0] = parts[0].substr(1)
    }

    if (parseInt(parts[0]) >= 0 && parseInt(parts[0]) <= 11) {
        let n = parseInt(parts[0])
        n = (n === 0 ? 12 : n)
        return n.toString() + ":" + parts[1] + " am"
    } else {
        let n = parseInt(parts[0]) - 12
        n = (n === 0 ? 12 : n)
        return n.toString() + ":" + parts[1] + " pm"
    }
}

export function format24hNoSpace(stringTime) {
    {/* "13:27:00" -> "1:27pm" */ }
    let parts = stringTime.split(":")

    if (parts[0].substr(0, 1) === "0") {
        parts[0] = parts[0].substr(1)
    }

    if (parseInt(parts[0]) >= 0 && parseInt(parts[0]) <= 11) {
        let n = parseInt(parts[0])
        n = (n === 0 ? 12 : n)
        return n.toString() + ":" + parts[1] + "am"
    } else {
        let n = parseInt(parts[0]) - 12
        n = (n === 0 ? 12 : n)
        return n.toString() + ":" + parts[1] + "pm"
    }
}

export function format24hHour(stringTime) {
    {/* "13:27:00" -> "1pm" */ }
    let parts = stringTime.split(":")

    if (parts[0].substr(0, 1) === "0") {
        parts[0] = parts[0].substr(1)
    }

    if (parseInt(parts[0]) >= 0 && parseInt(parts[0]) <= 11) {
        let n = parseInt(parts[0])
        n = (n === 0 ? 12 : n)
        return n.toString() + "am"
    } else {
        let n = parseInt(parts[0]) - 12
        n = (n === 0 ? 12 : n)
        return n.toString() + "pm"
    }
}